import truncate from 'lodash/truncate';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { StructuredData } from '../StructuredData/StructuredData';

const createTitle = (parts, separator = ' - ') =>
  Array.from(new Set(parts)).filter(Boolean).join(separator);

const MetaData = ({
  containerComponent,
  title = [],
  type,
  image,
  description,
  brandName,
}) => {
  const truncatedDescription =
    description &&
    truncate(description, {
      length: 300,
    });

  const fallbackImage = '/static/fallbackImages/metadataFallback.png';
  const formattedTitle = createTitle(title);

  return React.createElement(
    containerComponent,
    {},
    <Fragment>
      <title>{formattedTitle}</title>
      {truncatedDescription && (
        <meta
          key="description"
          name="description"
          content={truncatedDescription}
        />
      )}
      <meta key="robots" name="robots" content="follow,index" />
      <meta key="ogTitle" property="og:title" content={formattedTitle} />
      <meta key="ogSiteName" property="og:site_name" content={brandName} />
      <meta key="ogType" property="og:type" content={type} />
      {truncatedDescription && (
        <meta
          key="ogDescription"
          property="og:description"
          content={truncatedDescription}
        />
      )}
      <meta
        key="ogImage"
        property="og:image"
        content={image || fallbackImage}
      />
      <meta key="ogLocale" property="og:locale" content="nl_NL" />
      <StructuredData
        title={formattedTitle}
        image={image || fallbackImage}
        type={type}
      />
    </Fragment>
  );
};

MetaData.defaultProps = {
  image: null,
  description: null,
};

MetaData.propTypes = {
  containerComponent: PropTypes.func.isRequired,
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.string,
  brandName: PropTypes.string.isRequired,
};

export default MetaData;
